<template>
  <a-tooltip>
    <template #title>
      <template v-if="processed">Verwerkt</template>
      <template v-else-if="ignored">Genegeerd</template>
      <template v-else-if="needsVerification">Moet gecontroleerd worden</template>
      <template v-else>Er is iets mis gegaan bij het verwerken</template>
    </template>
    <span>
      <CheckCircleIcon
          v-if="processed"
          class="fill-success icon-size-md"/>
      <CancelIcon
          v-else-if="ignored"
          class="fill-danger icon-size-md"
      />
      <HelpCircleOutlineIcon
          v-else-if="needsVerification"
          class="fill-warning icon-size-md"
      ></HelpCircleOutlineIcon>
      <AlertIcon
          v-else
          class="fill-warning icon-size-md"
      ></AlertIcon>
    </span>
  </a-tooltip>
</template>

<script>
export default {
  name: 'AutomationResultStateCell',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  computed: {
    processed () {
      return this.row.processed_at !== null
    },
    ignored () {
      return this.row.ignored_at !== null
    },
    needsVerification () {
      return this.row.requires_verification
    }
  }
}
</script>

<style scoped>

</style>
